"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
/**
 * Insert an entity into editor.
 * @param editor The editor to insert entity into.
 * @param type Type of the entity
 * @param contentNode Root element of the entity
 * @param isBlock Whether the entity will be shown as a block
 * @param isReadonly Whether the entity will be a readonly entity
 * @param position (Optional) The position to insert into. If not specified, current position will be used.
 * If isBlock is true, entity will be insert below this position
 */
function insertEntity(editor, type, contentNode, isBlock, isReadonly, position) {
    var wrapper = roosterjs_editor_dom_1.wrap(contentNode, isBlock ? 'DIV' : 'SPAN');
    // For inline & readonly entity, we need to set display to "inline-block" otherwise
    // there will be some weird behavior when move cursor around the entity node.
    // And we should only do this for readonly entity since "inline-block" has some side effect
    // in IE that there will be a resize border around the inline-block element. We made some
    // workaround for readonly entity for this issue but for editable entity, keep it as "inline"
    // will just work fine.
    if (!isBlock && isReadonly) {
        wrapper.style.display = 'inline-block';
    }
    roosterjs_editor_dom_1.commitEntity(wrapper, type, isReadonly);
    if (!editor.contains(wrapper)) {
        var currentRange = void 0;
        var contentPosition = void 0;
        if (typeof position == 'number') {
            contentPosition = position;
        }
        else if (position) {
            currentRange = editor.getSelectionRange();
            var node = position.normalize().node;
            var existingEntity = node && editor.getElementAtCursor(roosterjs_editor_dom_1.getEntitySelector(), node);
            // Do not insert entity into another entity
            if (existingEntity) {
                position = new roosterjs_editor_dom_1.Position(existingEntity, -3 /* After */);
            }
            editor.select(position);
            contentPosition = 3 /* SelectionStart */;
        }
        else {
            editor.focus();
            contentPosition = 3 /* SelectionStart */;
        }
        editor.insertNode(wrapper, {
            updateCursor: false,
            insertOnNewLine: isBlock,
            replaceSelection: true,
            position: contentPosition,
        });
        if (contentPosition == 3 /* SelectionStart */) {
            if (currentRange) {
                editor.select(currentRange);
            }
            else if (!isBlock) {
                editor.select(wrapper, -3 /* After */);
            }
        }
    }
    if (isBlock) {
        // Insert an extra empty line for block entity to make sure
        // user can still put cursor below the entity.
        var br = editor.getDocument().createElement('BR');
        wrapper.parentNode.insertBefore(br, wrapper.nextSibling);
    }
    var entity = roosterjs_editor_dom_1.getEntityFromElement(wrapper);
    editor.triggerContentChangedEvent("InsertEntity" /* InsertEntity */, entity);
    return entity;
}
exports.default = insertEntity;
//# sourceMappingURL=insertEntity.js.map